let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1g4gU")).then(() => parcelRequire('jMyUD'));